// extracted by mini-css-extract-plugin
export default {"container":"container--32s9p"};